import styled from "styled-components";

export const Root = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
`;
